module.exports = __webpack_public_path__ + "img/icon-book.a5e931ba.png";